<template>
  <button type="button" class="country" @click="$emit('show-country-selector')">
    <svg class="flag" width="14" height="14" viewbox="0 0 14 14">
      <use v-bind:xlink:href="`#${current.flag}`"></use>
    </svg>
    <span>{{ $t(current.label) }}</span>
  </button>
</template>

<script>
export default {
  data() {
    return {
      countryList: [
        { value: 'CH', label: 'Switzerland', flag: 'flag-ch' },
        { value: 'DE', label: 'Germany', flag: 'flag-de' },
        { value: 'AT', label: 'Austria', flag: 'flag-at' },
        { value: 'LI', label: 'Liechtenstein', flag: 'flag-li' },
      ],
    }
  },
  computed: {
    selectedCountry() {
      return this.$store.state.user.shippingCountry
    },
    current() {
      return this.countryList.find((v) => v.value === this.selectedCountry)
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  border: 0;
  outline: none;
  padding: 0;
  color: $colorBlack;
  background: transparent;

  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;

  span {
    @include fontStyleFooterLink;
    display: inline-block;
    margin-left: 8px;
  }

  @include mq($to: tabletWide) {
    margin-bottom: 20px;
  }
}
</style>
